import ConfigurationAdapter from '../../../../config/ConfigurationAdapter';
import APIv4ProductRepository from '../../Infrastructure/APIv4ProductRepository';
import { GetProductByIdHandler } from '../UseCases/GetProductById';
import { GetRelatedProductsHandler } from '../UseCases/GetRelatedProducts';
import { GetProductsByCategoryHandler } from './GetProductsByCategory';
import { GetProductsByFiltersHandler } from './GetProductsByFilters';
import APIv4AuthCredentialsRepository from '../../../Auth/Infrastructure/Repositories/APIv4AuthCredentialsRepository';
import { GetProductsByFeedHandler } from './GetProductsByFeed';
import { GetProductBySkuHandler } from './GetProductBySku';
import { GetProductWithMetaproductsHandler } from './GetProductWithMetaproducts';
import StoreSearchRepository from '../../Infrastructure/StoreSearchRepository';
export * from './GetProductByCriteria';
// use cases
export const GetProductDetailUseCase = context => {
  const v4Context = ConfigurationAdapter.getV4Context(context);
  return new GetProductByIdHandler(new APIv4ProductRepository(v4Context, context.drivers.httpClient, context.drivers.meCachisDependencyService));
};
export const GetProductBySkuUseCase = context => {
  const v4Context = ConfigurationAdapter.getV4Context(context);
  return new GetProductBySkuHandler(new APIv4ProductRepository(v4Context, context.drivers.httpClient, context.drivers.meCachisDependencyService));
};
export const GetRelatedProductsUseCase = context => {
  const v4Context = ConfigurationAdapter.getV4Context(context);
  return new GetRelatedProductsHandler(new APIv4ProductRepository(v4Context, context.drivers.httpClient, context.drivers.meCachisDependencyService), new APIv4AuthCredentialsRepository(v4Context, context.drivers.httpClient));
};
export const GetProductsByCategoryUseCase = context => {
  const v4Context = ConfigurationAdapter.getV4Context(context);
  const repository = new APIv4ProductRepository(v4Context, context.drivers.httpClient, context.drivers.meCachisDependencyService);
  return new GetProductsByCategoryHandler(repository);
};
export const GetProductsByFeedUseCase = context => {
  const v4Context = ConfigurationAdapter.getV4Context(context);
  const repository = new StoreSearchRepository(v4Context, context.drivers.httpClient, context.drivers.meCachisDependencyService);
  return new GetProductsByFeedHandler(repository);
};
export const GetProductsByFiltersUseCase = context => {
  const v4Context = ConfigurationAdapter.getV4Context(context);
  return new GetProductsByFiltersHandler(new StoreSearchRepository(v4Context, context.drivers.httpClient, context.drivers.meCachisDependencyService));
};
export const GetProductWithMetaproductsUseCase = context => {
  const v4Context = ConfigurationAdapter.getV4Context(context);
  return new GetProductWithMetaproductsHandler(new APIv4ProductRepository(v4Context, context.drivers.httpClient, context.drivers.meCachisDependencyService));
};
